import { useEffect, useState } from "react";
import { useOrdersContext } from "@/contexts/OrderContext";
import useIndexedDB from "@/hooks/useIndexedDB";
import axios from "axios";

const useDeliveryFees = () => {
  const { cart, setCart, handleGetTotalPrice } = useOrdersContext(); // Get cart and setCart from the context
  const { isInitialized, saveCart } = useIndexedDB();
  const [canSaveCart, setCanSaveCart] = useState(false);

  const fetchAddressDeliveryFees = async () => {
    if (cart?.delivery_address) {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_API_URL}/api/delivery-fees/calculate`,
          {
            params: {
              zipcode: cart.delivery_address?.postal_code,
              region: cart.delivery_address?.region,
              country: cart.delivery_address?.country,
            },
          }
        );

        setCart((prevCart) => ({
          ...prevCart,
          delivery_fee_applied: response?.data,
        }));

        setCanSaveCart(true);
      } catch (error) {
        console.error("Erreur lors du calcul des frais de livraison:", error);
        // En cas d'erreur, aucun frais de livraison n'est appliqué
        setCart((prevCart) => ({
          ...prevCart,
          delivery_fee_applied: null,
        }));
        setCanSaveCart(true);
      }
    }
  };

  // Recalculer les frais de livraison quand le total change
  useEffect(() => {
    if (cart?.delivery_fee_applied) {
      const newDeliveryFee = handleCalculateDeliveryFee();
      setCart((prevCart) => ({
        ...prevCart,
        delivery_fee: newDeliveryFee,
      }));
      setCanSaveCart(true);
    }
  }, [handleGetTotalPrice().total]);

  useEffect(() => {
    if (isInitialized && canSaveCart) {
      const saveCartInIndexedDB = async () => {
        await saveCart(cart.restaurant_id, cart);
      };

      saveCartInIndexedDB();
      setCanSaveCart(false);
    }
  }, [canSaveCart]);

  const handleCalculateDeliveryFee = () => {
    if (
      (cart?.menus?.length === 0 && !cart.is_no_limit) ||
      (cart.is_no_limit &&
        cart.categories.every(
          (category) => category.extra_products.length === 0
        ))
    ) {
      return 0;
    }

    const baseFee = cart?.delivery_fee_applied?.price || 0;
    const tier = cart?.delivery_fee_applied?.tier || 1;
    const totalPrice = handleGetTotalPrice().total;

    // Calcul du nombre de paliers dépassés
    const numberOfTiers = Math.floor(totalPrice / tier);
    // Les frais augmentent du prix de base pour chaque palier dépassé
    const totalFee = baseFee + numberOfTiers * baseFee;

    return totalFee;
  };

  return { fetchAddressDeliveryFees, handleCalculateDeliveryFee };
};

export default useDeliveryFees;
